import type { GuideResultData } from './types';

export interface VendorInfo {
  id: string;
  name: string;
  location: string;
  category: string;
  intro: string;
  reasons: string[];
  reviewCount: number;
  photoCount: number;
  tags: string[];
  badge: string;
  reviewQuote: string;
  image: string;
}

export const suitVendors: Record<string, VendorInfo> = {
  billionstailor: {
    id: 'billionstailor',
    name: '빌리언즈테일러',
    location: '청담',
    category: '예복',
    intro: '대통령의 수트를 만든 손끝으로, 중요한 하루를 완성하는 인증업체입니다.',
    reasons: [
      '기성복과 수선 조합을 비교하기 좋아요.',
      '상담 설명이 자세하다는 후기가 많아요.',
      '본식 예복 기준을 잡기에 적합해요.',
    ],
    reviewQuote: '상담이 정말 자세해서 예복 기준을 잡기 좋았어요.',
    reviewCount: 199,
    photoCount: 526,
    tags: ['깔끔한 상담', '다양한 원단', '실속 예복'],
    badge: '먼저 볼 업체',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20luxury%20tailor%20shop%20interior%20with%20classic%20navy%20and%20charcoal%20wedding%20suits%20displayed%20on%20wooden%20mannequins%2C%20warm%20ambient%20lighting%20from%20brass%20chandelier%2C%20rich%20wood%20paneling%20and%20cream%20walls%2C%20refined%20artisanal%20atmosphere%2C%20soft%20shadows%2C%20sophisticated%20editorial%20photography%2C%20warm%20neutral%20tones&width=800&height=500&seq=vendor-card-billionstailor&orientation=landscape',
  },
  fortungarment: {
    id: 'fortungarment',
    name: '포춘가먼트',
    location: '압구정',
    category: '예복',
    intro: '신랑 예복만 15년, 한 길만 걸어온 장인이 직접 피팅부터 수선까지 책임집니다.',
    reasons: [
      '기성복부터 반수제까지 한 번에 비교할 수 있어요.',
      '체형 보정 노하우가 풍부하다는 평이에요.',
      '가격대별로 선택지가 다양해요.',
    ],
    reviewQuote: '체형 보정이 정말 자연스러워서 사진이 확 달라졌어요.',
    reviewCount: 312,
    photoCount: 748,
    tags: ['풍부한 경험', '체형 보정', '가격대 다양'],
    badge: '함께 비교할 업체',
    image: 'https://readdy.ai/api/search-image?query=Professional%20tailor%20measuring%20fabric%20on%20wooden%20workbench%20in%20warm%20lit%20workshop%2C%20rolls%20of%20premium%20suiting%20fabric%20in%20beige%20and%20grey%20tones%20on%20shelves%20behind%2C%20traditional%20tailoring%20scissors%20and%20measuring%20tape%2C%20soft%20natural%20window%20light%2C%20warm%20cream%20and%20sand%20color%20palette%2C%20artisanal%20craftsmanship%20photography&width=800&height=500&seq=vendor-card-fortungarment&orientation=landscape',
  },
  atelier: {
    id: 'atelier',
    name: '아뜰리에노블레스',
    location: '신사동',
    category: '예복',
    intro: '원단 컬렉션부터 디테일까지, 감각적인 신랑을 위한 프라이빗 예복 살롱입니다.',
    reasons: [
      '합리적인 가격대의 기성복 라인이 탄탄해요.',
      '피팅룸이 넓고 프라이빗해서 편안해요.',
      '당일 픽업 가능한 라인을 보유하고 있어요.',
    ],
    reviewQuote: '프라이빗한 공간에서 편하게 피팅할 수 있어서 좋았어요.',
    reviewCount: 176,
    photoCount: 403,
    tags: ['합리적 가격', '프라이빗 피팅', '빠른 준비'],
    badge: '먼저 볼 업체',
    image: 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20wedding%20suit%20boutique%20interior%20with%20warm%20wooden%20floor%20and%20large%20mirror%2C%20stylish%20beige%20and%20light%20grey%20suits%20on%20display%20rack%2C%20soft%20natural%20light%20streaming%20through%20frosted%20glass%20windows%2C%20potted%20greenery%20accents%2C%20cream%20and%20terracotta%20tones%2C%20clean%20editorial%20photography%2C%20sophisticated%20yet%20welcoming%20atmosphere&width=800&height=500&seq=vendor-card-atelier&orientation=landscape',
  },
  heritztailor: {
    id: 'heritztailor',
    name: '헤리츠테일러',
    location: '청담',
    category: '예복',
    intro: 'Loro Piana, Scabal 등 프리미엄 원단을 직접 취급하는 장인급 테일러샵입니다.',
    reasons: [
      '명품 원단 샘플북을 직접 비교해볼 수 있어요.',
      '1:1 전담 테일러가 처음부터 끝까지 책임져요.',
      '프리미엄 라인을 경험하기에 가장 추천하는 곳이에요.',
    ],
    reviewQuote: '원단 샘플북 보는 것만으로도 특별한 경험이었어요.',
    reviewCount: 287,
    photoCount: 612,
    tags: ['프리미엄 원단', '1:1 전담', '장인 핸드메이드'],
    badge: '먼저 볼 업체',
    image: 'https://readdy.ai/api/search-image?query=Luxury%20premium%20tailor%20atelier%20with%20exquisite%20fabric%20sample%20books%20open%20on%20marble%20table%2C%20rolls%20of%20fine%20italian%20wool%20and%20cashmere%20in%20warm%20earth%20tones%20on%20display%2C%20soft%20golden%20pendant%20lighting%2C%20sophisticated%20cream%20and%20camel%20interior%20with%20dark%20wood%20accents%2C%20refined%20craftsmanship%20atmosphere%2C%20editorial%20product%20photography%2C%20elegant%20and%20exclusive%20feel&width=800&height=500&seq=vendor-card-heritztailor&orientation=landscape',
  },
};

export interface UpgradeGuideData {
  title: string;
  description: string;
  conditions: string[];
}

export const suitUpgradeGuides: Record<string, UpgradeGuideData | null> = {
  readyMade: {
    title: '반수제도 고려해볼 만한 경우',
    description:
      '기성복도 훌륭한 선택이지만, 아래 조건에 해당한다면 반수제 맞춤으로 한 단계 업그레이드했을 때 만족도가 훨씬 높아질 수 있어요.',
    conditions: [
      '기성복을 입었을 때 어깨나 허리 라인이 많이 어색한 편',
      '촬영 사진에서 핏이 중요하게 보였으면 하는 경우',
      '결혼식 이후에도 오래 입을 한 벌로 맞추고 싶은 경우',
      '마음에 드는 브랜드나 원단을 찾기 어려운 경우',
    ],
  },
  semiBespoke: {
    title: '풀 비스포크도 고려해볼 만한 경우',
    description:
      '반수제는 가성비가 뛰어나지만, 핏과 디테일에 더 욕심이 난다면 풀 비스포크라는 선택지도 열어두세요.',
    conditions: [
      '체형이 비대칭이거나 표준에서 크게 벗어난 경우',
      '원단과 디테일에 더 신경 쓰고 싶은 경우',
      '어깨부터 밑단까지 완벽한 핏을 원하는 경우',
      '커스텀 디테일(라펠, 단추, 안감)을 자유롭게 선택하고 싶은 경우',
    ],
  },
  bespoke: {
    title: '프리미엄 라인도 고려해볼 만한 경우',
    description:
      '풀 비스포크만으로도 충분히 만족스럽지만, 원단과 장인 정신에 프리미엄을 더하고 싶다면 아래 조건을 체크해보세요.',
    conditions: [
      '최상급 원단(Loro Piana, Scabal 등)의 촉감과 광택을 경험해보고 싶은 경우',
      '예복을 평생 소장할 자산으로 생각하는 경우',
      '장인급 테일러의 핸드메이드 퀄리티를 원하는 경우',
      '한정 생산 원단으로 더 특별한 예복을 만들고 싶은 경우',
    ],
  },
  classic: null,
};

export const suitResultCheckPoints: Record<string, string[]> = {
  readyMade: [
    '피팅 후 소매·밑단 수선 가능 여부',
    '촬영복 대여 포함 여부',
    '결혼식 이후 재착용 가능성',
  ],
  semiBespoke: [
    '최소 2회 이상 피팅 일정 확보',
    '원단 샘플북 직접 확인',
    '수선 범위와 추가 비용 사전 확인',
  ],
  bespoke: [
    '첫 상담 전 원하는 핏 이미지 준비',
    '3회 이상 피팅 일정 확보',
    '원단·라펠·단추 등 디테일 옵션 확인',
  ],
  classic: [
    '원단 샘플북 사전 요청',
    '장인급 테일러 포트폴리오 확인',
    '8~12주 충분한 제작 기간 확보',
  ],
};

const upgradeOrder = ['readyMade', 'semiBespoke', 'bespoke', 'classic'];

export function getUpgradeResult(
  currentKey: string,
  results: GuideResultData[]
): GuideResultData | null {
  const idx = upgradeOrder.indexOf(currentKey);
  if (idx < 0 || idx >= upgradeOrder.length - 1) return null;
  const nextKey = upgradeOrder[idx + 1];
  return results.find((r) => r.key === nextKey) || null;
}